import { render, staticRenderFns } from "./StocktakeQrCode.vue?vue&type=template&id=8c1388fc&scoped=true&"
import script from "./StocktakeQrCode.vue?vue&type=script&lang=js&"
export * from "./StocktakeQrCode.vue?vue&type=script&lang=js&"
import style0 from "./StocktakeQrCode.vue?vue&type=style&index=0&id=8c1388fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1388fc",
  null
  
)

export default component.exports